import { render, staticRenderFns } from "./bigDialog.vue?vue&type=template&id=235e37c2&scoped=true&"
import script from "./bigDialog.vue?vue&type=script&lang=js&"
export * from "./bigDialog.vue?vue&type=script&lang=js&"
import style0 from "./bigDialog.vue?vue&type=style&index=0&id=235e37c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e37c2",
  null
  
)

export default component.exports